import { z } from "zod";
const count = z.number().int().nonnegative();
export const staffOrderAlertHistoryV1Schema = z
    .object({
    contract: z.literal("LC_STAFF_ORDER_ALERT_HISTORY_V1"),
    physicalOrderId: z.string().min(1).max(240),
    coverage: z.literal("V2_PER_RECIPIENT_LEDGER_ONLY_LEGACY_IDENTITIES_UNAVAILABLE"),
    feedbackMode: z.enum(["ENABLED", "DISABLED_NO_OBSERVATIONS_EXPECTED"]),
    alerts: z
        .array(z
        .object({
        kind: z.string().regex(/^[A-Z_]{1,80}$/u),
        incidentPresent: z.boolean(),
        status: z.enum([
            "ALL_ACCEPTED",
            "RECONCILIATION_REQUIRED",
            "RETRY_REQUIRED",
            "NO_RECIPIENTS",
            "LEGACY_OUTCOME_UNKNOWN",
        ]),
        counts: z
            .object({
            recipients: count,
            accepted: count,
            alreadyAccepted: count,
            unknown: count,
            failedNotAccepted: count,
            unidentified: count,
            deliveredObserved: count,
            bouncedObserved: count,
            complainedObserved: count,
            delayedObserved: count,
            rejectedObserved: count,
            renderingFailedObserved: count,
        })
            .strict(),
        updatedAt: z.string().datetime({ offset: true }),
        readObserved: z.literal(false),
    })
        .strict())
        .max(50),
    truncated: z.boolean(),
    truthBoundary: z.literal("COUNTS_ONLY_NO_RECIPIENT_IDENTITY_PROVIDER_ID_OR_READ_RECEIPT"),
})
    .strict();
//# sourceMappingURL=book-staff-alert-history.js.map